import axios from "axios";
import { AccountType } from "models/account_type";
import { ContaFinanceiro } from "models/conta_financeiro";
import { PessoaType } from "models/person_type";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";

const useContaFinanceiro = () => {
  const [contaFinanceiroLista, setContaFinanceiroLista] = useState<
    ContaFinanceiro[]
  >([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [accountSelected, setAccountSelected] = useState<ContaFinanceiro>(null);
  const [tipoConta, setTipoConta] = useState<AccountType[]>([]);
  const [selectedConta, setSelectedConta] = useState<AccountType>(null);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const cancelRef = useRef();
  const [filiais, setFilial] = useState<PessoaType[]>();
  const [selectedFilial, setSelectedFilial] = useState<PessoaType>();

  const showModal = (show: boolean) => {
    setShow(show);
    setError(false);
    if (!show) {
      setAccountSelected(null);
      setSelectedConta(null);
    }
  };

  const add = () => {
    showModal(true);
  };

  const edit = async (item: ContaFinanceiro) => {
    showModal(true);
    setAccountSelected(item);
    onChangeSelectedConta(item?.idTipoConta);
    onChangeFilial(item?.empresaSaiadaId);
  };

  const changeInput = (type: any, value: string) => {
    switch (type) {
      case "idTipoConta":
        setAccountSelected({ ...accountSelected, idTipoConta: value });
        break;
      case "banco":
        setAccountSelected({ ...accountSelected, banco: value });
        break;
      case "agencia":
        setAccountSelected({ ...accountSelected, agencia: value });
        break;
      case "tipo":
        setAccountSelected({ ...accountSelected, tipo: value });
        break;
      case "numero":
        setAccountSelected({ ...accountSelected, numero: value });
        break;
      case "validade":
        setAccountSelected({ ...accountSelected, validade: value });
        break;
      case "titular":
        setAccountSelected({ ...accountSelected, titular: value });
        break;
      case "tipoPessoa":
        setAccountSelected({ ...accountSelected, tipoPessoa: value });
        break;
      case "documento":
        setAccountSelected({ ...accountSelected, documento: value });
        break;
      case "descricao":
        setAccountSelected({ ...accountSelected, descricao: value });
        break;
    }
  };

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const closeError = () => {
    setError(false);
  };
  const validateField = (condition: any, errorMessage: string) => {
    if (!condition) {
      showError("Erro!", errorMessage);
      return false;
    }
    return true;
  };
  const validate = () => {
    let response = true;
    response =
      validateField(
        accountSelected?.documento,
        "Preencha Corretamente o Documento do Titular"
      ) && response;
    response =
      validateField(
        accountSelected?.tipo,
        "Preencha Corretamente o tipo da conta"
      ) && response;
    response =
      validateField(
        accountSelected?.tipoPessoa,
        "Preencha Corretamente o tipo de pessoa"
      ) && response;
    response =
      validateField(
        accountSelected?.agencia,
        "Preencha Corretamente a agencia"
      ) && response;
    response =
      validateField(accountSelected?.banco, "Preencha Corretamente o banco") &&
      response;
    response =
      validateField(
        accountSelected?.titular,
        "Preencha Corretamente o titular"
      ) && response;

    response =
      validateField(
        accountSelected?.descricao,
        "Preencha Corretamente a descrição"
      ) && response;
    response =
      validateField(
        accountSelected?.numero,
        "Preencha Corretamente o número da conta/cartão"
      ) && response;
    response =
      validateField(
        selectedConta,
        "Preencha Corretamente a categoria da conta"
      ) && response;

      response =
      validateField(
        selectedFilial,
        "Preencha Corretamente a Filial para a Conta"
      ) && response;


    return response;
  };
  const save = async () => {
    setError(false);
    if (validate()) {
      if (!accountSelected.id) {
        await addRegister();
      } else {
        await updateRegister();
      }
      await loadData();
    }


  };

  const loadData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/conta-financeiro/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setContaFinanceiroLista(response.data);
    }
  };

  const loadTipoConta = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/conta-tipo/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setTipoConta(response.data);
    }
  };

  const loadEmpresas = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcamento/filial/" + userData?.idEmpresa
    );
    if (response.data) {
      setFilial(response.data);
    }
  };

  const addRegister = async () => {
    const obj: ContaFinanceiro = {
      ...accountSelected,
      idTipoConta: selectedConta.id,
      idEmpresa: usuario.idEmpresa,
      empresaSaiadaId: selectedFilial.id
    };
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/conta-financeiro/",
      obj
    );

    if (response.data) {
      setLoading((prev) => (prev = false));
      showModal(false);
    }
  };

  const updateRegister = async () => {
    const obj: ContaFinanceiro = {
      ...accountSelected,
      idTipoConta: selectedConta.id,
      empresaSaiadaId: selectedFilial.id
    };
    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/conta-financeiro/" + accountSelected.id,
      obj
    );
    if (response.data === true) {
      setLoading((prev) => (prev = false));
      showModal(false);
    }
  };

  const showDeleteModal = (item: ContaFinanceiro) => {
    setShowDelete(true);
    setAccountSelected(item);
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const deletar = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/conta-financeiro/" + accountSelected?.id
    );
    if (response.data === true) {
      setLoading((prev) => (prev = false));
      showModal(false);
      setAccountSelected(null);
      setShowDelete(false);
      await loadData();
    }
  };

  const onChangeSelectedConta = (item: string) => {
    const selected = tipoConta.find((a) => a.id === item);
    if (selected) {
      setSelectedConta(selected);
    }
  };

  const onChangeFilial = (item: string) => {
    const selected = filiais.find((a) => a.id === item);
    if (selected) {
      setSelectedFilial(selected);
    }
  }

  useEffect(() => {
    const initialize = async () => {
      try {
        await Promise.all([loadData(), loadTipoConta(), loadEmpresas()]);
      } catch (error) {
        // Handle errors if needed
        console.error("Error during initialization:", error);
      }
    };
    initialize();
  }, []);

  return {
    add,
    contaFinanceiroLista,
    showDeleteModal,
    closeDelete,
    deletar,
    save,
    cancelRef,
    selectedConta,
    tipoConta,
    showDelete,
    error,
    show,
    loading,
    usuario,
    onChangeSelectedConta,
    edit,
    changeInput,
    closeError,
    showError,
    errorMsg,
    errorTitle,
    accountSelected,
    showModal,
    filiais,
    selectedFilial,
    onChangeFilial
  };
};
export default useContaFinanceiro;
